import { render, staticRenderFns } from "./LevelProgress.vue?vue&type=template&id=08827204&scoped=true&"
import script from "./LevelProgress.vue?vue&type=script&lang=js&"
export * from "./LevelProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08827204",
  null
  
)

export default component.exports